import NotificationCard from '@/components/notification/NotificationCard.vue'
import notify from './function'

export default{
    install(Vue) {
        Vue.component(NotificationCard.name, NotificationCard)
        // Vue.prototype 是 Vue 的原型对象，它是一个空的对象，可以在其上定义属性和方法，这些属性和方法会被所有 Vue 实例共享。
        Vue.prototype.$notify = notify
    }
}